module.exports = __webpack_public_path__ + "media/images/weather/66_day-6a06c1ec130d1797680ace5fadbf2d01.png";